import { FC, useContext } from 'react';

import { CUSTOM_COMES_AFTER_TAG_RECORD } from '@/constants/inventory';
import { NewInventoryFiltersContext } from '@/contexts/NewInventoryFiltersContext';
import { isFilterSection } from '@/tools/inventory';
import { BaseTagFilterItem, FilterSection } from '@/types/inventory';
import { ClientEnv } from '@/env';
import { useEnv } from '@/env/client';

const filterSectionEnvVars: Partial<Record<FilterSection, keyof ClientEnv>> = {
  [FilterSection.SLEEPS]: 'ENABLE_SLEEPS_FILTER',
};

export type FilterSectionsSectionComponent = FC<{ section: FilterSection }>;
export type FilterSectionsTagComponent = FC<{ item: BaseTagFilterItem }>;

interface FilterSectionsProps {
  sectionComponent: FilterSectionsSectionComponent;
  tagComponent: FilterSectionsTagComponent;
}

export const FilterSections = ({
  sectionComponent: SectionComponent,
  tagComponent: TagComponent,
}: FilterSectionsProps) => {
  const { baseTagFilters } = useContext(NewInventoryFiltersContext);
  const { env } = useEnv();

  const items: (FilterSection | BaseTagFilterItem)[] = Object.values(FilterSection);

  for (const item of baseTagFilters) {
    const comesAfter = CUSTOM_COMES_AFTER_TAG_RECORD[item.name];

    if (comesAfter) {
      const index = items.indexOf(comesAfter);
      if (index !== -1) {
        items.splice(index + 1, 0, item);
        continue;
      }
    }

    items.push(item);
  }

  return items.map((item) => {
    if (typeof item === 'string') {
      if (filterSectionEnvVars[item] && !env[filterSectionEnvVars[item]]) {
        return null;
      }

      return <SectionComponent section={item} key={item} />;
    }

    if (isFilterSection(item.name)) return null;

    return <TagComponent item={item} key={item.name} />;
  });
};
